"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "usePrismicFooter", {
  enumerable: true,
  get: function get() {
    return _usePrismicFooter["default"];
  }
});
Object.defineProperty(exports, "fetcher", {
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
});
var _usePrismicFooter = _interopRequireDefault(require("./usePrismicFooter"));
var _fetcher = _interopRequireDefault(require("./fetcher"));